import React from "react";
import { useTranslation } from "react-i18next";

const BorderReviwerSection = () => {
  const { t } = useTranslation();
  return (
    <section className="section-border wow fadeInUp">
      <div className="container">
        <div className="row">
          <div className="col">
            <article className="border-block">
              <div className="border-block_in">
                <div className="border-block_content">
                  <div className="row">
                    <div className="col-md-5">
                      <h3>{t("reviewerBlocksTitle1")}</h3>
                    </div>
                    <div className="col-md-7">
                      {t("reviewerBlocksDesc11")}
                      <br />
                      {t("reviewerBlocksDesc12")}
                      <br />
                      {t("reviewerBlocksDesc13")}
                    </div>
                  </div>
                </div>
              </div>
            </article>
          </div>
        </div>
      </div>
    </section>
  );
};
export default BorderReviwerSection;
